<div class="bank-account-detail-container">
    <h1>Account Summary</h1>
    <mat-card class="bank-account-overview-card">
        <mat-card-header>
            <mat-card-subtitle>{{AccountType}}</mat-card-subtitle>
            <mat-card-title *ngIf="accountLoading === true">
                <div class="skeleton skeleton-text"></div>
            </mat-card-title>
            <mat-card-title *ngIf="accountLoading === false">{{account.Name}}</mat-card-title>
            <img *ngIf="accountLoading === false && account.BankLogoUrl" mat-card-avatar
                src="{{account.BankLogoUrl}}" />
        </mat-card-header>
        <mat-card-content>
            <div *ngIf="accountLoading === false">
                <div fxLayout="row wrap" fxLayoutAlign="space-between center">
                    <div class="bank-account-overview-data-element">
                        <div class="bank-account-overview-data-val-lg">{{account.CurrentBalance | currency}}</div>
                        <div><small>Current Balance</small></div>
                    </div>
                    <div *ngIf="account.AvailableBalance !== undefined" class="bank-account-overview-data-element">
                        <div class="bank-account-overview-data-val-lg">{{account.AvailableBalance | currency}}</div>
                        <div><small>Available Balance</small></div>
                    </div>
                    <div *ngIf="account.CreditLimit !== undefined" class="bank-account-overview-data-element">
                        <div class="bank-account-overview-data-val-lg">{{account.CreditLimit | currency}}</div>
                        <div><small>Credit Limit</small></div>
                    </div>
                    <div class="bank-account-overview-data-element">
                        <div class="bank-account-overview-data-val-lg">{{account.FormattedAccount}}</div>
                        <div><small>Account Number</small></div>
                    </div>
                </div>
                <div fxLayout="row wrap" fxLayoutAlign="end center">
                    <div>
                        <div><small>Updated: {{account.BalanceRefreshedAt | amDateFormat:'ddd Do MMM, h:mm a'}}</small>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="accountLoading === true">
                <div fxLayout="row wrap" fxLayoutAlign="space-between center">
                    <div class="bank-account-overview-data-element">
                        <div class="skeleton skeleton-data-lg"></div>
                        <div class="skeleton skeleton-label"></div>
                    </div>
                    <div class="bank-account-overview-data-element">
                        <div class="skeleton skeleton-data-lg"></div>
                        <div class="skeleton skeleton-label"></div>
                    </div>
                    <div class="bank-account-overview-data-element">
                        <div class="skeleton skeleton-data-lg"></div>
                        <div class="skeleton skeleton-label"></div>
                    </div>
                    <div class="bank-account-overview-data-element">
                        <div class="skeleton skeleton-data-lg"></div>
                        <div class="skeleton skeleton-label"></div>
                    </div>
                </div>
                <div fxLayout="row wrap" fxLayoutAlign="end center">
                    <div>
                        <div><small>
                                <div class="skeleton skeleton-text"></div>
                            </small></div>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
    <mat-card class="bank-account-balance-ytd-card" *ngIf="dailyBalanceNotFound !== true">
        <mat-card-header class="bank-account-balance-ytd-card-header">
            <mat-card-subtitle>{{ balanceTrendToShow === 'oneYear' ? 'Last 12 months' : 'Balance YTD'}}</mat-card-subtitle>
            <!-- <div><small>Show</small>
                <mat-radio-group aria-label="Select an option" [(ngModel)]="balanceTrendToShow"
                    (change)="onDailyBalanceGraphChange()">
                    <mat-radio-button value="ytd">Year to date</mat-radio-button>
                    <mat-radio-button value="oneYear">1 Year</mat-radio-button>
                </mat-radio-group>
            </div> -->
        </mat-card-header>
        <mat-card-content>
            <app-daily-balance-line-chart [dailyBalance]="dailyBalance" [showTicks]="isMobile == false"></app-daily-balance-line-chart>
        </mat-card-content>
    </mat-card>
    <mat-card class="bank-account-transactions-card">
        <mat-card-header class="bank-account-transactions-card-header">
            <mat-card-subtitle>Recent Transactions</mat-card-subtitle>
            <div><small>Show</small>
                <mat-radio-group aria-label="Select an option" [(ngModel)]="numberOfTransactions"
                    (change)="onNumberOfTransactionsChange()">
                    <mat-radio-button *ngFor="let opt of numberOfTransactionsOptions" [value]="opt">
                        {{opt}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </mat-card-header>
        <mat-card-content>
            <div *ngIf="transLoading === false && transactionsNotFound === false">
                <div fxLayout="row wrap" fxLayoutAlign="space-between center">
                    <table mat-table [dataSource]="transactions">
                        <ng-container matColumnDef="icons">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td nowrap mat-cell *matCellDef="let trans">
                                <mat-icon *ngIf="trans.TransactionType && !trans.MerchantLogo" aria-hidden="false"
                                    fontIcon="{{getTransactionTypeIcon(trans.TransactionType)}}"></mat-icon>
                                <img *ngIf="trans.MerchantLogo" class="bank-account-transactions-merchant-logo"
                                    src="{{trans.MerchantLogo}}" />
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="transDate">
                            <th mat-header-cell *matHeaderCellDef>Date</th>
                            <td nowrap mat-cell *matCellDef="let trans">
                                {{trans.TransactionDate | amDateFormat:'ddd Do MMM yyyy'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="transShortDate">
                            <th mat-header-cell *matHeaderCellDef>Date</th>
                            <td nowrap mat-cell *matCellDef="let trans">
                                {{trans.TransactionDate | amDateFormat:'DD MMM'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="description_mobile">
                            <th mat-header-cell *matHeaderCellDef>Description</th>
                            <td mat-cell *matCellDef="let trans">
                                <div *ngIf="trans.MerchantName">
                                    {{ trans.MerchantName }}
                                </div>
                                <div *ngIf="trans.IncomeType">
                                    {{getIncomeText(trans)}}
                                </div>
                                <div *ngIf="!trans.MerchantName && !trans.IncomeType">{{ trans.Description }}</div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="description_desktop">
                            <th mat-header-cell *matHeaderCellDef>Description</th>
                            <td mat-cell *matCellDef="let trans">
                                <div fxLayout="column">
                                    <div *ngIf="trans.MerchantName">
                                        <div fxLayout="row" fxAlign="center begin">
                                            {{ trans.MerchantName }} &nbsp;<mat-icon inline="true"
                                                fontSet="material-icons-outlined" [matTooltip]="trans.Description">
                                                info</mat-icon>
                                                &nbsp;<a *ngIf="trans.MerchantWebsite" style="color: black;" [href]="trans.MerchantWebsite" target="_blank" type="button"><mat-icon inline="true" fontSet="material-icons-outlined">open_in_new</mat-icon></a>
                                        </div>
                                    </div>
                                    <div *ngIf="trans.IncomeType">
                                        {{getIncomeText(trans)}}
                                    </div>
                                    <div *ngIf="!trans.MerchantName && !trans.IncomeType">{{ trans.Description }}</div>
                                    <div *ngIf="trans.TransactionCategoryGroup && trans.TransactionCategory">
                                        <small>{{trans.TransactionCategoryGroup}} /
                                            {{trans.TransactionCategory}}</small>
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="group">
                            <th mat-header-cell *matHeaderCellDef>Group / Category</th>
                            <td mat-cell *matCellDef="let trans">
                                <div *ngIf="trans.TransactionCategoryGroup && trans.TransactionCategory">
                                    {{trans.TransactionCategoryGroup}} / {{trans.TransactionCategory}}
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="category">
                            <th mat-header-cell *matHeaderCellDef>Category</th>
                            <td mat-cell *matCellDef="let trans"></td>
                        </ng-container>
                        <ng-container matColumnDef="meta">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let trans">
                                <button mat-icon-button
                                    *ngIf="trans.TransactionCategory || trans.TransactionCategoryGroup"
                                    matTooltip="Info about the action">
                                    <mat-icon fontSet="material-icons-outlined">category</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="amt">
                            <th mat-header-cell *matHeaderCellDef>Amount</th>
                            <td mat-cell *matCellDef="let trans">{{trans.Amount | currency}}</td>
                        </ng-container>
                        <ng-container matColumnDef="bal">
                            <th mat-header-cell *matHeaderCellDef>Balance</th>
                            <td mat-cell *matCellDef="let trans">{{trans.Balance | currency}}</td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="transactionsDisplayColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: transactionsDisplayColumns;"></tr>
                    </table>
                </div>
                <div fxLayout="row wrap" fxLayoutAlign="end center">
                    <div>
                        <div><small>Updated: {{account.TransactionsRefreshedAt | amDateFormat:'ddd Do MMM, h:mm
                                a'}}</small></div>
                    </div>
                </div>
            </div>
            <div *ngIf="transLoading === true && transactionsNotFound === false" fxLayout="column nowrap"
                fxLayoutAlign="space-between center">
                <div class="skeleton skeleton-table-row "></div>
                <div class="skeleton skeleton-table-row"></div>
                <div class="skeleton skeleton-table-row"></div>
                <div class="skeleton skeleton-table-row"></div>
                <div class="skeleton skeleton-table-row"></div>
                <div class="skeleton skeleton-table-row"></div>
                <div class="skeleton skeleton-table-row"></div>
                <div class="skeleton skeleton-table-row"></div>
            </div>
            <div *ngIf="transactionsNotFound === true">
                <h3>Not bank transactions found!</h3>
            </div>
        </mat-card-content>
    </mat-card>
    <app-fab-menu [buttons]="fabButtons" icon="build"></app-fab-menu>
</div>